/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface NotificationTargetCategory
 */
export interface NotificationTargetCategory {
    /**
     * 알림 대상 카테고리 id
     * @type {number}
     * @memberof NotificationTargetCategory
     */
    'notificationTargetCategoryId': number;
    /**
     * 카테고리
     * @type {string}
     * @memberof NotificationTargetCategory
     */
    'category': NotificationTargetCategoryCategoryEnum;
}

export const NotificationTargetCategoryCategoryEnum = {
    Baby: 'baby',
    Friends: 'friends',
    Family: 'family',
    Supporters: 'supporters',
    Guardian: 'guardian',
    AllUser: 'allUser',
    EachUser: 'eachUser'
} as const;

export type NotificationTargetCategoryCategoryEnum = typeof NotificationTargetCategoryCategoryEnum[keyof typeof NotificationTargetCategoryCategoryEnum];


